import { createSelector } from '@ngrx/store';

import { getEstateState } from '../../reducers';

export const selectEstateState = createSelector(getEstateState, (state) => state);
